import "./FileFull.scss";
import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";
import { editableExtensions } from "../../../config";

export default {
  props: {
    mySpace: Number,
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      file: false,
      loading: false,
    };
  },

  created() {
    EventBus.$on(`closeallactions`, this.close);

    EventBus.$on("file-full--loading-done", () => this.handleDoneLoading());

    this.getFileData();
  },
  methods: {
    checkIfFullScreen() {
      return this.file.extension !== ".figma";
    },
    setEmbedUrl() {
      if (this.file.extension === ".url") {
        if (
          this.file.location.match(
            /https:\/\/([\w\.-]+\.)?figma.com\/(file|proto)\/([0-9a-zA-Z]{22,128})(?:\/.*)?$/
          )
        ) {
          this.file.extension = ".figma";
        }
      }
    },
    handleDoneLoading() {
      this.loading = false;
    },

    showEditor() {
      let present = false;

      editableExtensions.forEach((ext) => {
        if (ext === this.file.extension) {
          present = true;
        }
      });

      return present;
    },
    getFileData() {
      if (this.show) {
        this.file = false;

        this.$axios
          .get(
            `${baseUrl}/file?file=${this.$route.params.file}&myspace=${this.mySpace}&res=full&tags=true`,
            {
              responseType: "json",
            }
          )
          .then((response) => {
            this.file = response.data;

            if (this.file.dimensions) {
              this.file["width"] = parseInt(this.file.dimensions.split("x")[0]);
              this.file["height"] = parseInt(
                this.file.dimensions.split("x")[1]
              );
            }

            this.setEmbedUrl();

            if (this.showEditor()) {
              this.loading = true;
            }
          });
      }
    },
    close() {
      this.$router.push(
        this.$route.fullPath.replace("/detail", "").replace("/edit", "")
      );
    },
  },
  computed: {
    canEdit() {
      return editableExtensions.includes(this.file.extension);
    },
  },
  watch: {
    file() {},
    show() {
      this.getFileData();
    },
    $route() {
      if (this.file) {
        if (this.showEditor()) {
          this.loading = true;
        }
      }
    },
  },
};
